<div class="d-flex gap-3">
  <div class="container-box shadow-none flex-fill">
    <div class="d-flex gap-3 align-items-center p-3">
      <img src="/assets/images/channel-wizards/step-icon1.webp" alt="" height="40" />
      <div>
        <h6 class="mb-0" i18n>Preparation</h6>
        <div class="text-sm">
          <ng-container i18n>This section will prepare you for connecting Tiket.com with AdvanceCM.</ng-container>
          <br />
          <ng-container i18n>Please read through these instructions carefully before proceeding.</ng-container>
        </div>
      </div>
    </div>
    <div class="border-top p-4">
      <div>
        <mat-accordion>
          <mat-expansion-panel [expanded]="true" #start>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="step-number mr-2">1</div>
                <ng-container i18n>Create or Import Rentals</ng-container>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="">
              <div class="text-semi-bold" i18n>To connect your AdvanceCM rental to Tiket.com, follow these steps:</div>
              <ul class="pl-3 lh-lg">
                <li i18n>Ensure you have created or imported a rental from Airbnb into AdvanceCM.</li>
                <li i18n>Connecting with Airbnb first is recommended for convenience.</li>
                <li i18n>Follow this guide for detailed instructions.</li>
              </ul>
              <div class="alert alert-secondary-warning2 align-items-start">
                <i class="cs-icon cs-icon-alert-triangle2 alert-icon"></i>
                <div class="alert-content">
                  <b i18n>Note:</b>
                  <ng-container i18n
                    >One AdvanceCM rental can be connected to multiple channels. Combined availability from all channels
                    will be synced.</ng-container
                  >
                </div>
              </div>

              <div class="text-right">
                <button class="btn btn-light-info" (click)="blocked.open()">
                  <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
                </button>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel #blocked>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="step-number mr-2">2</div>
                <ng-container i18n>Blocked Dates</ng-container>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <ul class="pl-3 lh-lg">
                <li i18n>
                  After connecting AdvanceCM with Tiket.com, your availability will be determined by your AdvanceCM
                  rental calendar.
                </li>
                <li i18n>
                  Please ensure you replicate any manual hold events on your channels in the AdvanceCM calendar to keep
                  dates blocked. Hold events set on Tiket.com are not imported when connecting to a channel manager.
                </li>
                <li i18n>Follow this guide for detailed instructions.</li>
              </ul>
              <div class="alert alert-secondary-warning2 align-items-start">
                <i class="cs-icon cs-icon-alert-triangle2 alert-icon"></i>
                <div class="alert-content">
                  <b i18n>Note:</b>
                  <ng-container i18n
                    >One AdvanceCM rental can be connected to multiple channels. Combined availability from all channels
                    will be synced.</ng-container
                  >
                </div>
              </div>

              <div class="text-right">
                <button class="btn btn-light-info" (click)="prepare.open()">
                  <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
                </button>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel #prepare>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="step-number mr-2">3</div>
                <ng-container i18n>Preparing Rates</ng-container>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <p i18n>
                Once connected to Tiket.com, your rates and availability will be disabled until you complete all steps
                in the wizard. Moving forward, rates must be pushed from AdvanceCM to Tiket.com; direct edits on
                Tiket.com's rates calendar will not be possible.
              </p>
              <div class="text-semi-bold" i18n>Key Considerations</div>
              <ul class="pl-3 lh-lg">
                <li i18n>
                  Pushing Rates: Pushing rates to Tiket.com is required. Prepare your rates using this guide before
                  beginning.
                </li>
                <li i18n>
                  Creating Rates: You can create a rate within the connection wizard and make changes later. If your
                  rate plan is straightforward, adding the rate within the wizard is recommended.
                </li>
                <li i18n>
                  Guest Fees: Ensure your Tiket.com rates accept additional guest fees if applicable. Finalize your rate
                  plans on Tiket.com.
                </li>
              </ul>

              <div class="alert alert-secondary-warning2 align-items-start">
                <img
                  src="/assets/images/integrations/rategenie.png"
                  alt="Rategenie"
                  class="alert-icon"
                  style="height: 1.5rem"
                />
                <div class="alert-content">
                  <b class="text-nowrap" i18n>Recommended Tool:</b>
                  <ng-container i18n>We highly recommend using</ng-container>
                  <a href="https://www.rategenie.io/" target="_blank">Rategenie</a>
                  <ng-container i18n
                    >for rental rate management, as it is the most advanced dynamic pricing application in the
                    industry.</ng-container
                  >
                </div>
              </div>

              <div class="text-right">
                <button class="btn btn-light-info" (click)="messaging.open()">
                  <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
                </button>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel #messaging>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="step-number mr-2">4</div>
                <ng-container i18n>Messaging</ng-container>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <ul class="pl-3 lh-lg">
                <li i18n>Messaging your Tiket.com guests is not supported through a channel manager.</li>
                <li i18n>
                  For any inquiries, hotel partners should email cs@tiket.com or contact the Market Manager of
                  Tiket.com, whose contact information is available on the extranet.
                </li>
              </ul>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div class="mt-5 d-flex align-items-center justify-content-between">
        <button class="btn btn-outline-light" (click)="prev.emit()">
          <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
          <ng-container i18n>Previous</ng-container>
        </button>
        <button class="btn btn-secondary-info" (click)="next.emit()">
          <ng-container i18n>Next</ng-container>
          <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="channel-wizard-right-wrapper rounded px-4">
    <img src="/assets/images/channel-wizards/step2.webp" alt="" class="w-100" />
  </div>
</div>
